import { RouterModule } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { environment } from 'src/environments/environment';
import { ContentPipe } from 'src/app/services/content/content.pipe';
import { ContentPipeModule } from 'src/app/services/content/content-pipe.module';
import { RoutesManager } from 'src/app/shared/models/routes.interfaces';

@Component({
    selector: 'thank-you-page',
    templateUrl: './thank-you-page.component.html',
    styleUrls: ['./thank-you-page.component.scss'],
    imports: [CommonModule, RouterModule, ContentPipeModule, NgOptimizedImage]
})
export class ThankYouPageComponent implements OnInit {

  userHomePage: string;

  userHomePageText: string;
  
  assetsUrl = environment.assets.url;

  constructor(
    private contentPipe: ContentPipe,
  ) { }

  ngOnInit(): void {
    this.userHomePage = `/${RoutesManager.homePage}`;
    this.userHomePageText = this.contentPipe.transform(`common.thankYouPageNavigateHome`);
  }
}
